<div class="spinner-wrap">
  <mat-spinner
    class="global-mat-spinner"
    diameter="150"
  ></mat-spinner>
</div>
